import React, { useState, useEffect } from 'react';

import PortalButton from '../components/Button';
import SignAgreement from './OnboardingComponents/SignAgreement';
import StarterKit from './OnboardingComponents/StarterKit';
import W9form from './OnboardingComponents/W9form';
// eslint-disable-next-line react/prop-types

function Onboarding() {
  const [selected, setselected] = useState(1);

  return (
    <div className="flex flex-col mx-auto space-y-4 max-w-4xl">
      <div className="flex justify-center ">
        <div className="w-full  border border-neutral-50 p-5 md:p-10 shadow-xl">
          <div className="flex-col">
            <h4 className="text-portal-600 text-2xl font-semibold mr-10">Onboarding</h4>
            <p className="text-statustext-600 text-md md:text-lg  ">
              Please complete the followiong steps in order to finish onboarding.
            </p>
          </div>
          <hr className="my-10"></hr>
          <div className="relative mt-10">
            <div className="absolute left-0  w-full h-5 bg-progress-100  rounded-full " aria-hidden="true"></div>
            <ul className="relative flex justify-between w-full text-sm text-semibold">
              <li className=" cursor-pointer" onClick={() => setselected(1)}>
                <div className="flex relative h-10  justify-start">
                  <span
                    className={
                      'flex w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                      (selected >= 1 ? 'bg-progress-300' : 'bg-progress-600')
                    }></span>
                </div>
                <div className="flex relative justify-start">
                  <span className={selected === 1 ? 'font-semibold' : ''}>Sign Agreement</span>
                </div>
              </li>
              <li className=" cursor-pointer" onClick={() => setselected(2)}>
                <div className="flex relative h-10  justify-center">
                  <span
                    className={
                      'flex w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                      (selected >= 2 ? 'bg-progress-300' : 'bg-progress-600')
                    }></span>
                </div>
                <div className="flex relative justify-start">
                  <span className={selected === 2 ? 'font-semibold' : ''}>Submit W9</span>
                </div>
              </li>
              <li className=" cursor-pointer" onClick={() => setselected(3)}>
                <div className="flex relative h-10  justify-end">
                  <span
                    className={
                      'flex  w-5 h-5 mb-5 rounded-full text-xs font-semibold  text-slate-500 ' +
                      (selected >= 3 ? 'bg-progress-300' : 'bg-progress-600')
                    }></span>
                </div>
                <div className="flex relative justify-start">
                  <span className={selected === 3 ? 'font-semibold' : ''}>Choose Starter Kit</span>
                </div>
              </li>
            </ul>
          </div>
          <div className={'relative mt-10 ' + (selected === 1 ? 'block' : 'hidden')}>
            <div className="h-auto">
              <SignAgreement />
            </div>

            <div className="grid gap-1 md:grid-cols-3 mt-5">
              <PortalButton variant="primary" text="Next - Submit W9" classes="px-10" onClick={() => setselected(2)} />
            </div>
          </div>
          <div className={'relative mt-10 ' + (selected === 2 ? 'block' : 'hidden')}>
            <div className="h-auto">
              <W9form />
            </div>
            <div className="grid gap-1 md:grid-cols-3 mt-5">
              <PortalButton variant="primary" text="Next - Choose Starter Kit" classes="px-10" onClick={() => setselected(3)} />
            </div>
          </div>

          <div className={'relative mt-10 ' + (selected === 3 ? 'block' : 'hidden')}>
            <StarterKit />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Onboarding;
